// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-content_root__XTdtm","truncateContainer":"snippet-content_truncateContainer__AL89G","chip":"snippet-content_chip__8oFRG"};